import { useEffect } from "react";

const SuccessPage = ({ setCart }) => {

  useEffect(() => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    const email = localStorage.getItem("email");

    let myOrder = "";
    let total = 0;

    myOrder += email + " has ordered: ";

    for (const item of cart) {
      total += parseFloat(item.price);
      myOrder += "\r\n" + item.name + " - $" + item.price;
    }

    myOrder += "\r\nTotal: $" + total;

    fetch("https://high-and-fly-1.onrender.com/api/contact/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: "Customer",
        email,
        message: myOrder,
      }),
    });

    //clear all cart data from localStorage and sync with state
    localStorage.setItem("cart", JSON.stringify([]));
    setCart([]);

  }, [setCart]);

  return (
    <div className="success-page">
      <h1>Payment Successful</h1>
      <a href="/">Return to Home</a>
    </div>
  );
};

export default SuccessPage;